import { ListItemText, MenuItem, styled } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  alignItems: 'flex-start',
  borderTop: `${theme.spacing(0.5)} solid ${theme.palette.primary.main}`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  opacity: '1 !important',
  width: '100%',
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '&&': {
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.75),
    padding: 0,
  },

  '& .MuiListItemText-primary': {
    color: theme.palette.primary.main,
    fontWeight: 700,
    textTransform: 'uppercase',
  },

  '& .MuiListItemText-secondary': {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(1.75),
  },
}));

export const useStyles = makeStyles((theme: ITheme) => ({
  gpcInUse: {
    color: theme.palette.text.secondary,
    fontSize: '1.25em',
    marginLeft: theme.spacing(1),
  },
  isBenchmarkCheckBox: {
    padding: 0,
    marginLeft: theme.spacing(1),
  },
  approachValuesContainer: {
    alignItems: 'flex-start',
    borderTop: `${theme.spacing(0.5)} solid ${theme.palette.primary.main}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    opacity: '1 !important',
    width: '100%',
  },
  approachValues: {
    '& .MuiListItemText-primary': {
      color: theme.palette.primary.main,
      fontWeight: 700,
      textTransform: 'uppercase',
    },

    '& .MuiListItemText-secondary': {
      color: theme.palette.primary.main,
      fontSize: theme.spacing(1.75),
    },
  },
}));
